<template>
  <div class="tag-score">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-left-panel :span="20">
        <el-form inline @submit.prevent="query(1)">
          <el-form-item label="账号名称">
            <el-input v-model="queryParams.name" clearable placeholder="请输入" @change="query(1)" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="queryParams.phone" clearable placeholder="请输入" @change="query(1)" />
          </el-form-item>
          <el-form-item label="标记分级">
            <el-select v-model="queryParams.violationType" clearable placeholder="请选择" @change="query(1)">
              <el-option v-for="item in options[TAG_LEVEL]" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="4">
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
        <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="ID" prop="uid" />
      <el-table-column label="账号名称" prop="name" />
      <el-table-column label="手机号" prop="phone" />
      <el-table-column label="标记分级">
        <template #default="{ row }">
          {{ optionsMap[TAG_LEVEL][row.violationType] }}
        </template>
      </el-table-column>
      <el-table-column label="违规次数" prop="violationCount" />
      <el-table-column align="center" label="操作">
        <template #default="{ row }">
          <el-link type="primary" :underline="false" @click="tagLevelModal.open(row)">修改分级</el-link>
          <el-link type="primary" :underline="false" @click="tagScoreDetailModal.open(row)">查看详情</el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 修改分级 -->
    <el-dialog
      destroy-on-close
      :model-value="tagLevelModal.visible"
      title="处理"
      :width="480"
      @closed="tagLevelModal.close"
    >
      <TagScoreForm
        ref="tagScoreFormRef"
        :options="options[TAG_LEVEL]"
        :uid="tagLevelModal.data.uid"
        :violation-type="tagLevelModal.data.violationType"
        @success="onTagLevelSuccess"
      />
      <template #footer>
        <el-button @click="tagLevelModal.close">取消</el-button>
        <el-button type="primary" @click="tagScoreFormRef.submit()">确定</el-button>
      </template>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog
      center
      destroy-on-close
      :model-value="tagScoreDetailModal.visible"
      title="查看详情"
      :width="860"
      @closed="tagScoreDetailModal.close"
    >
      <TagScoreDetail :uid="tagScoreDetailModal.data.uid" />
      <template #footer>
        <el-button @click="tagScoreDetailModal.close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { omit } from 'lodash'
  import TagScoreForm from './TagScoreForm.vue'
  import TagScoreDetail from './TagScoreDetail.vue'
  import { getViolationList, getComplaintJSON } from '@/api/jbh'
  import { useModal } from '@/hooks/useModal'

  const defaultQueryParams = {
    name: '',
    phone: '',
    violationType: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }
  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  const IDENTITY = 'IDENTITY'
  const TAG_LEVEL = 'TAG_LEVEL'
  const options = ref({})
  const optionsMap = ref({})

  function getOptions() {
    getComplaintJSON().then((res) => {
      const map = {},
        opt = {}
      ;[IDENTITY, TAG_LEVEL].forEach((key) => {
        const data = res.options[key]
        if (!Array.isArray(data)) return
        data.forEach(([value, label]) => {
          if (!map[key]) map[key] = {}
          if (!opt[key]) opt[key] = []
          map[key][value] = label
          opt[key].push({ value, label })
        })
      })
      options.value = opt
      optionsMap.value = map
    })
  }

  onMounted(() => {
    query()
    getOptions()
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true

    getViolationList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  const tagScoreFormRef = ref()
  const tagLevelModal = useModal()

  const tagScoreDetailModal = useModal()

  function onTagLevelSuccess() {
    query()
    tagLevelModal.close()
  }
</script>

<style lang="scss" scoped>
  .tag-score {
    padding: 16px;
  }
</style>
